import React from 'react';

export interface UserDetailsContactFieldsProps {
  mobile?: string | null;
  home?: string | null;
  office?: string | null;
  mailingAddress?: string | null;
  ministerId?: string | null;
}

const hasValue = (value?: string | null): value is string =>
  typeof value === 'string' && value.trim() !== '';

const DetailRow: React.FC<{ label: string; value: string; preWrap?: boolean }> = ({
  label,
  value,
  preWrap,
}) => (
  <div className="mb-3">
    <div className="text-muted small">{label}</div>
    <div className={`text-break${preWrap ? ' text-pre-wrap' : ''}`}>{value}</div>
  </div>
);

const UserDetailsContactFields: React.FC<UserDetailsContactFieldsProps> = ({
  mobile,
  home,
  office,
  mailingAddress,
  ministerId,
}) => (
  <>
    {hasValue(mobile) ? <DetailRow label="Mobile" value={mobile.trim()} /> : null}
    {hasValue(home) ? <DetailRow label="Home" value={home.trim()} /> : null}
    {hasValue(office) ? <DetailRow label="Office" value={office.trim()} /> : null}
    {hasValue(mailingAddress) ? (
      <DetailRow label="Mailing address" value={mailingAddress.trim()} preWrap />
    ) : null}
    {hasValue(ministerId) ? <DetailRow label="Minister ID" value={ministerId.trim()} /> : null}
  </>
);

export default UserDetailsContactFields;
